export default "__VITE_PUBLIC_ASSET__c6c09bf1__"